var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          "serial-width": "100",
          selection: _vm.hasBtn && _vm.selection,
          stripe: false,
          "right-toolbar-hide": "",
          "hide-search": _vm.hideSearch,
          "row-key": "id",
          "reset-data": _vm.resetDataFn,
          "tree-select-auto-parent": "",
          lazy: "",
          load: _vm.loadMethod,
          "row-style": _vm.$treeRowStyleFun,
        },
        on: { handleSelectionChange: _vm.handleSelectionChange },
        scopedSlots: _vm._u(
          [
            {
              key: "baseForm",
              fn: function () {
                return [
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "BusinessOrderAuditComSkuList.receivingStatus"
                            ),
                            prop: "receiveStatus",
                          },
                        },
                        [
                          _c("BjSelectLov", {
                            attrs: {
                              "constant-key":
                                "ORDER_INTERNAL_SKU_RECEIVING_STATUS_LIST",
                            },
                            model: {
                              value: _vm.queryParams.receiveStatus,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "receiveStatus", $$v)
                              },
                              expression: "queryParams.receiveStatus",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.businessType == _vm.ORDER_BUSINESS_TYPES.COMMON
                    ? [
                        _c(
                          "el-col",
                          { attrs: { span: _vm.colSpan } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "BusinessOrderAuditComSkuList.deliveryStatus"
                                  ),
                                  prop: "deliveryStatus",
                                },
                              },
                              [
                                _c("BjSelectLov", {
                                  attrs: {
                                    "constant-key":
                                      "ORDER_INTERNAL_SKU_DELIVER_STATUS_LIST",
                                  },
                                  model: {
                                    value: _vm.queryParams.deliveryStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "deliveryStatus",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.deliveryStatus",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: _vm.colSpan } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "BusinessOrderAuditComSkuList.preemptionStatus"
                                  ),
                                  prop: "preemptionStatus",
                                },
                              },
                              [
                                _c("BjSelectLov", {
                                  attrs: {
                                    "constant-key":
                                      "ORDER_INTERNAL_SKU_PREEMPT_STATUS_LIST",
                                  },
                                  model: {
                                    value: _vm.queryParams.preemptionStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "preemptionStatus",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.preemptionStatus",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: _vm.colSpan } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "BusinessOrderAuditComSkuList.sourceStatus"
                                  ),
                                  prop: "sourceStatus",
                                },
                              },
                              [
                                _c("BjSelectLov", {
                                  attrs: {
                                    "constant-key":
                                      "ORDER_INTERNAL_SKU_SOURCE_STATUS_LIST",
                                  },
                                  model: {
                                    value: _vm.queryParams.sourceStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "sourceStatus",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.sourceStatus",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: _vm.colSpan } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "BusinessOrderAuditComSkuList.suspendStatus"
                                  ),
                                  prop: "suspendStatus",
                                },
                              },
                              [
                                _c("BjSelectLov", {
                                  attrs: {
                                    "constant-key":
                                      "ORDER_INTERNAL_SKU_HAND_UP_STATUS_LIST",
                                  },
                                  model: {
                                    value: _vm.queryParams.suspendStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "suspendStatus",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.suspendStatus",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: _vm.colSpan } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "BusinessOrderAuditComSkuList.syncPreempStatus"
                                  ),
                                  prop: "syncPreempStatus",
                                },
                              },
                              [
                                _c("BjSelectLov", {
                                  attrs: {
                                    "constant-key":
                                      "ORDER_INTERNAL_SKU_PREEMPT_BACK_STATUS_LIST",
                                  },
                                  model: {
                                    value: _vm.queryParams.syncPreempStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "syncPreempStatus",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.syncPreempStatus",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: _vm.colSpan } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "BusinessOrderAuditComSkuList.syncDeliveryStatus"
                                  ),
                                  prop: "syncDeliveryStatus",
                                },
                              },
                              [
                                _c("BjSelectLov", {
                                  attrs: {
                                    "constant-key":
                                      "ORDER_INTERNAL_SKU_STOCK_BACK_STATUS_LIST",
                                  },
                                  model: {
                                    value: _vm.queryParams.syncDeliveryStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "syncDeliveryStatus",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "queryParams.syncDeliveryStatus",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            _vm.hasBtn
              ? {
                  key: "startBtnGroup",
                  fn: function () {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.onAction(
                                _vm.$t("BusinessOrderAuditComSkuList.receipt")
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("BusinessOrderAuditComSkuList.receipt")
                            )
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.onAction(
                                _vm.$t("BusinessOrderAuditComSkuList.hangUp")
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("BusinessOrderAuditComSkuList.hangUp")
                            )
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.onAction(
                                _vm.$t("BusinessOrderAuditComSkuList.hang")
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("BusinessOrderAuditComSkuList.hang"))
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "tableColumn",
              fn: function () {
                return [
                  _vm._l(_vm.dropCols, function (col, index) {
                    return [
                      col.prop !== "bjTableAction"
                        ? _c("el-table-column", {
                            key:
                              "col_" +
                              index +
                              "_" +
                              col.prop +
                              "_" +
                              (col.width || "auto"),
                            attrs: {
                              prop: col.prop,
                              label: col.label,
                              width: col.width || "auto",
                              fixed: col.fixed || false,
                              align: "center",
                              "class-name": "item",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      false
                                        ? void 0
                                        : col.prop === "spuName"
                                        ? [
                                            scope.row.setFlag == 1
                                              ? _c("el-tag", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "BusinessOrderAuditComSkuList.cover"
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(
                                              " " +
                                                _vm._s(scope.row[col.prop]) +
                                                " "
                                            ),
                                          ]
                                        : col.prop === "giftFlag"
                                        ? [
                                            _c(
                                              "el-tag",
                                              {
                                                attrs: {
                                                  type: scope.row.giftFlag
                                                    ? "success"
                                                    : "info",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.STATUS_YES_NUM.bjGet(
                                                        !!scope.row.giftFlag
                                                      )
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        : col.prop === "refundFlag"
                                        ? [
                                            _c(
                                              "el-tag",
                                              {
                                                attrs: {
                                                  type: scope.row.refundFlag
                                                    ? "success"
                                                    : "info",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.STATUS_YES_NUM.bjGet(
                                                        !!scope.row.refundFlag
                                                      )
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        : col.prop
                                            .toLocaleLowerCase()
                                            .includes("amount") ||
                                          col.prop
                                            .toLocaleLowerCase()
                                            .includes("price")
                                        ? [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$number2money(
                                                    scope.row[col.prop]
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        : col.prop === "deliveryStatus"
                                        ? [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.ORDER_INTERNAL_SKU_DELIVER_STATUS_LIST.concat(
                                                      _vm.ORDER_INTERNAL_LINE_DELIVER_STATUS_LIST
                                                    ).bjGet(scope.row[col.prop])
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        : col.prop === "receivingStatus"
                                        ? [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.ORDER_INTERNAL_SKU_RECEIVING_STATUS_LIST.concat(
                                                      _vm.ORDER_INTERNAL_LINE_RECEIVING_STATUS_LIST
                                                    ).bjGet(scope.row[col.prop])
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        : col.prop === "preemptionStatus"
                                        ? [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.ORDER_INTERNAL_SKU_PREEMPT_STATUS_LIST.concat(
                                                      _vm.ORDER_INTERNAL_LINE_PREEMPT_STATUS_LIST
                                                    ).bjGet(scope.row[col.prop])
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        : col.prop === "sourceStatus"
                                        ? [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.ORDER_INTERNAL_SKU_SOURCE_STATUS_LIST.concat(
                                                      _vm.ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST
                                                    ).bjGet(scope.row[col.prop])
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        : col.prop === "suspendStatus"
                                        ? [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.ORDER_INTERNAL_SKU_HAND_UP_STATUS_LIST.concat(
                                                      _vm.ORDER_INTERNAL_LINE_HAND_UP_STATUS_LIST
                                                    ).bjGet(scope.row[col.prop])
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        : col.prop === "syncPreempStatus"
                                        ? [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.ORDER_INTERNAL_SKU_PREEMPT_BACK_STATUS_LIST.concat(
                                                      _vm.ORDER_INTERNAL_LINE_PREEMPT_BACK_STATUS_LIST
                                                    ).bjGet(scope.row[col.prop])
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        : col.prop === "syncDeliveryStatus"
                                        ? [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.ORDER_INTERNAL_SKU_STOCK_BACK_STATUS_LIST.concat(
                                                      _vm.ORDER_INTERNAL_LINE_STOCK_BACK_STATUS_LIST
                                                    ).bjGet(scope.row[col.prop])
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("timeFilters")(
                                                  scope.row[col.prop],
                                                  scope.row[col.prop]
                                                )
                                              )
                                            ),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                      col.prop === "bjTableAction"
                        ? _c("el-table-column", {
                            key:
                              "col_" +
                              index +
                              "_" +
                              col.prop +
                              "_" +
                              (col.width || "auto"),
                            attrs: {
                              prop: col.prop,
                              label: col.label,
                              width: col.width || "auto",
                              fixed: col.fixed || "right",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDetail(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("viewText")))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _vm._e(),
                    ]
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }